/* tslint:disable */
/* eslint-disable */

/**
 * Service type
 */
export enum TcaServiceType {
  DineIn = 'DineIn',
  BringToTable = 'BringToTable',
  Pickup = 'Pickup',
  DriveThru = 'DriveThru',
  Curbside = 'Curbside',
  DeliveryByRestaurant = 'DeliveryByRestaurant',
  Delivery = 'Delivery'
}
